<template>
    <div class="page">
        <RouterView />

        <link rel="stylesheet" :href="themePath" />
        
        <Modals />
        <Messages />
    </div>
</template>

<script setup>
import { onMounted, computed } from 'vue';

import Messages from '🔗/components/ui/Messages.vue';
import Modals from '@/components/modals/Modals.vue';

import { storeToRefs } from 'pinia';
import stores from '@/stores';

const others = stores.others();
const { themePath } = storeToRefs(others);

const messengers = stores.messengers();
const user = stores.user();
const modals = stores.modals();
const nav = stores.nav();

onMounted(async () => {
    await messengers.init();

    if (!stores.messengers().canLogin()) {
        return;
    }

    modals.open('loader');
    // Login
    await user.login();

    if (user.token) {
        nav.open('music');
        return;
    }

    setTimeout(() => {
        modals.close('loader');
    }, 2500)

});
</script>

<style scoped lang="scss">
</style>
